import React from "react";
import {applicationRootPath} from "../../infrastructure/config";

export const NoMatch = () => (
  <div className="info-page" style={{height: "500px"}}>
    <div className="info-page-block block bg-white block-shadow">
      <div className="d-flex flex-column flex-sm-row align-items-center">
        <div className="info-page-icon">
          <i className="fal fa-exclamation-circle"></i>
        </div>
        <div className="info-page-content">
          <h1 className="avenir-bold info-page-title">Sorry, we couldn&apos;t find that page</h1>
          <p>
            The page you&apos;re searching for doesn&apos;t exist&nbsp;anymore, either it has been
            moved or the link is broken.
          </p>
          <a
            href={applicationRootPath}
            className="router-link-active info-page-link"
            target="_self">
            Go to homepage
          </a>
        </div>
      </div>
    </div>
  </div>
);
